export class RefSystemeIrrigation {
    id: number;
    code: string;
    libelle: string;
}
